const latinRegex = /^((?![_×÷])[\u0026-\u007B\u007D-\u007E\u00BF-\u00DF\u00E0-\u00FF\u0100-\u024F\u2019 ])+$/;
const chineseRegex = /^((?![_×÷])[\u0027-\u007B\u007D-\u007E\u00BF-\u00DF\u00E0-\u00FF\u0100-\u024F\u4e00-\u62ff\u6300-\u77ff\u7800-\u8cff\u8d00-\u9fcc\u3000-\u303F\u3040-\u309F\u30A0-\u30FF ])+$/;

export const REGEX_SCHEMA_BY_COUNTRY = {
  firstName: {
    CN: chineseRegex,
    DEFAULT: latinRegex,
  },
  lastName: {
    CN: chineseRegex,
    DEFAULT: latinRegex,
  },
  name: {
    CN: chineseRegex,
    DEFAULT: latinRegex,
  },
  address1: {
    CN: chineseRegex,
    DEFAULT: latinRegex,
  },
  city: {
    CN: chineseRegex,
    DEFAULT: latinRegex,
  },
  postalCode: {
    US: /^\d{5}$/,
    CA: /^[A-Za-z0-9]{3} ?[0-9A-Za-z]{3}$/,
    CN: /^\d{6}$/,
    SG: /^[0-9]{3}-?[0-9]{3}$/,
    JP: /^[0-9]{3}-?[0-9]{4}$/,
    DEFAULT: /^[\w\-\s]+$/,
  },
};

export const FIELD_ERROR_KEY = {
  firstName: {
    CN: 'enterValidField',
    DEFAULT: 'enterValidField',
  },
  lastName: {
    CN: 'enterValidField',
    DEFAULT: 'enterValidField',
  },
  name: {
    CN: 'enterValidField',
    DEFAULT: 'enterValidField',
  },
  address1: {
    CN: 'address1ErrorMessage',
    DEFAULT: 'address1ErrorMessage',
  },
  city: {
    CN: 'cityMissing',
    DEFAULT: 'cityMissing',
  },
  postalCode: {
    US: 'postalUSCodeErrorMessage',
    CA: 'postalCACodeErrorMessage',
    CN: 'postalCodeErrorMessage',
    SG: 'postalCodeErrorMessage',
    JP: 'postalCodeErrorMessage',
    DEFAULT: 'postalCodeErrorMessage',
  },
};

export const getFieldRegexSchema = (key, countryCode, isAPOFPO) => {
  if (!REGEX_SCHEMA_BY_COUNTRY[key]) return null;

  if (key === 'postalCode' && isAPOFPO) return REGEX_SCHEMA_BY_COUNTRY[key].DEFAULT;

  return REGEX_SCHEMA_BY_COUNTRY[key][countryCode] ?? REGEX_SCHEMA_BY_COUNTRY[key].DEFAULT;
};

export const getFieldErrorKey = (key, countryCode) => {
  if (!FIELD_ERROR_KEY[key]) return null;

  return FIELD_ERROR_KEY[key][countryCode] ?? FIELD_ERROR_KEY[key].DEFAULT;
};

export const validateField = (key, value, countryCode, isAPOFPO) => {
  const regEx = getFieldRegexSchema(key, countryCode, isAPOFPO);
  if (!regEx) {
    return true;
  }

  return (!!value && regEx.test(value)) || getFieldErrorKey(key, countryCode);
};

export const validatePostalCode = (value, countryCode, isAPOFPO) => {
  if (!value) return false;

  const regEx = getFieldRegexSchema('postalCode', countryCode, isAPOFPO);
  if (!regEx) {
    return true;
  }

  return !!value && regEx.test(value);
};

export const getValidationSchema = (countryCode, isAPOFPO) => ({
  firstName: (value) => validateField('firstName', value, countryCode),
  lastName: (value) => validateField('lastName', value, countryCode),
  address1: (value) => validateField('address1', value, countryCode),
  city: (value) => validateField('city', value, countryCode),
  postalCode: (value) => validateField('postalCode', value, countryCode, isAPOFPO),
});

export function getValueByDotKey(obj, key) {
  if (!obj || typeof obj !== 'object') return undefined;
  if (!key) return obj;

  const keys = key.split('.');
  return keys.reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj);
}
